import createCustomCategory from "./MapLocationCategoryUtil";
import * as MarkerIcons from '../MapMarkerIcons';
import FilterManager from "./FilterManager";
import MapLocation from "./MapLocation";
var BaseMap = /** @class */ (function () {
    function BaseMap(mapData, lineData, container) {
        this.mapMarker = [];
        this.lineData = [];
        // Agilis Headquarter Regensburg
        this.startingLocation = new MapLocation(-1, 49.00987704221752, 12.100368753816005, '', [createCustomCategory('Init')]);
        this.container = container;
        this.lineData = lineData;
        this.mapData = mapData.map(function (it) {
            if (it.maps)
                return new MapLocation(it.id, it.maps.lat, it.maps.lng, it.title, it.categories, it.teaser, it.links);
            else
                return new MapLocation(it.id, it.lat, it.lng, it.title, it.categories, it.teaser, it.links);
        });
        this.filterManager = new FilterManager(this);
        this.getLocation(this.getLocationCallback.bind(this));
    }
    /**
     * Attempts to get the users location
     * @param callback
     */
    BaseMap.prototype.getLocation = function (callback) {
        callback(this.startingLocation.lat, this.startingLocation.lng);
        // Don't use user location, always use startingLocation
        /*if (!navigator.geolocation) callback(this.startingLocation.lat, this.startingLocation.lng);

        navigator.geolocation.getCurrentPosition(
            function (position) {
                callback(position.coords.latitude, position.coords.longitude);
            },
            function (error) {
                console.debug("geolocation.getCurrentPosition() => %o", error);
                callback(this.startingLocation.lat, this.startingLocation.lon);
            }
        )*/
    };
    /**
     * Callback function used for geolocation API
     * @param lat
     * @param lng
     */
    BaseMap.prototype.getLocationCallback = function (lat, lng) {
        var _this = this;
        var userLocation = new MapLocation(-1, lat, lng, '', [createCustomCategory('User')]);
        this.map = this.initializeMap(userLocation);
        this.createUserMarker(userLocation);
        // add marker to map
        this.mapData.forEach(function (it) {
            _this.createMarker(it, MarkerIcons.getIconForCategory(it));
        });
        this.filterManager.applyFilter();
        // add polylines
        this.lineData.forEach(function (line) {
            _this.createPolyline(line.title, line.color, line.locationIds.map(_this.getLocationById.bind(_this)));
        });
    };
    //-------------------------------------------
    BaseMap.prototype.createMarker = function (location, icon, keepTrack) {
        if (keepTrack === void 0) { keepTrack = true; }
        var marker = this.createMarkerInternal(location, icon);
        if (keepTrack)
            this.mapMarker.push(marker);
        return marker;
    };
    /**
     * Locations are provided by the mapData array
     * @param id
     * @returns
     */
    BaseMap.prototype.getLocationById = function (id) {
        var filtered = this.mapData.filter(function (it) { return it.id == id; });
        return filtered.length == 0 ? null : filtered[0];
    };
    return BaseMap;
}());
export default BaseMap;
